import {Box, BoxProps} from '@chakra-ui/react'
import {LuMessageSquareText} from 'react-icons/lu'

// the amber speech bubble shared by note badges; inherits color from its context
export function NoteIcon(props: BoxProps) {
  return (
    <Box asChild {...props}>
      <LuMessageSquareText size="1em" />
    </Box>
  )
}

// amber speech bubble marking a step (or notes button) that carries a note;
// purely visual: pointer events never reach it and it never opens the note
export function NoteBadge(props: BoxProps) {
  return (
    <Box
      position="absolute"
      top="-1.5"
      insetEnd="-1.5"
      width="4"
      height="4"
      rounded="sm"
      bg="orange.400"
      color="white"
      display="flex"
      alignItems="center"
      justifyContent="center"
      pointerEvents="none"
      {...props}
    >
      <NoteIcon />
    </Box>
  )
}
